
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ChartDataLabels
);

const MonthlyDutyTrend = ({ data = [] }) => {
  const rows = Array.isArray(data) ? data : [];

  const labels = rows.map((item) => item.month ?? "");
  const values = rows.map((item) =>
    Number(item.total_duties ?? item.total ?? 0)
  );

  const chartData = {
    labels,
    datasets: [
      {
        label: "Duties",
        data: values,
        fill: true,
        borderWidth: 3,
        borderColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return "#4f46e5";
          const gradient = ctx.createLinearGradient(
            chartArea.left,
            0,
            chartArea.right,
            0
          );
          gradient.addColorStop(0, "#0ea5e9");
          gradient.addColorStop(0.5, "#3b82f6");
          gradient.addColorStop(1, "#7c3aed");
          return gradient;
        },
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return "rgba(59, 130, 246, 0.16)";
          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(124, 58, 237, 0.36)");
          gradient.addColorStop(0.55, "rgba(59, 130, 246, 0.22)");
          gradient.addColorStop(1, "rgba(14, 165, 233, 0.08)");
          return gradient;
        },
        tension: 0.38,
        pointRadius: 5,
        pointHoverRadius: 7,
        pointBackgroundColor: "#ffffff",
        pointBorderColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return "#4f46e5";
          const gradient = ctx.createLinearGradient(
            chartArea.left,
            0,
            chartArea.right,
            0
          );
          gradient.addColorStop(0, "#0ea5e9");
          gradient.addColorStop(0.5, "#3b82f6");
          gradient.addColorStop(1, "#7c3aed");
          return gradient;
        },
        pointBorderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: "#0f172a",
        titleColor: "#ffffff",
        bodyColor: "#e2e8f0",
        padding: 10,
        displayColors: false,
        callbacks: {
          label: (context) => `Duties: ${context.parsed.y}`,
        },
      },
      datalabels: {
        display: true,
        align: "top",
        anchor: "end",
        offset: 3,
        color: (context) =>
          context.dataIndex >= Math.max(0, values.length - 2)
            ? "#6d28d9"
            : "#2563eb",
        font: {
          size: 11,
          weight: "600",
        },
        formatter: (value) => value,
        clamp: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
          color: "rgba(148, 163, 184, 0.16)",
          borderDash: [4, 4],
          drawTicks: false,
        },
        border: { display: false },
        ticks: {
          color: "#64748b",
          maxRotation: 0,
          autoSkip: true,
          font: { size: 11 },
        },
      },
      y: {
        beginAtZero: true,
        suggestedMax: Math.max(5, ...values) * 1.18,
        grid: {
          color: "rgba(148, 163, 184, 0.20)",
          borderDash: [4, 4],
          drawTicks: false,
        },
        border: { display: false },
        ticks: {
          color: "#64748b",
          precision: 0,
          padding: 8,
          font: { size: 11 },
        },
      },
    },
  };

  return (
    <section className="min-w-0 rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm">
      {/* <h3 className="mb-3 text-sm font-semibold text-slate-900">
        Monthly Duties Trend
      </h3> */}
      <div className="h-[190px] w-full sm:h-[220px]">
        {rows.length > 0 ? (
          <Line data={chartData} options={options} />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-slate-400">
            No monthly duty data available
          </div>
        )}
      </div>
    </section>
  );
};

export default MonthlyDutyTrend;
